import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs/operators';
import { SnackBarType } from '../../shared/models/snack-bar-config.model';
import { getCompaniesFailureAction } from '../companies/companies.actions';
import { getPermissionsFailureAction } from '../permissions/permissions.actions';
import {
    deleteUserFailureAction,
    editUserPermissionsFailureAction,
    getSiteFailureAction,
    getSiteFeaturesFailureAction,
    getSiteLicenseRawFailureAction,
    getSitesFailureAction,
    getSiteUsersFailureAction,
    inviteUserFailureAction,
} from '../sites/sites.actions';
import {
    activateDeviceCareFailureAction,
    clearDeviceCareFailureAction,
    getSiteDeviceCareConfigFailureAction,
    getSiteMetricDataFailureAction,
    getSiteMetricsConfigFailureAction,
    updateSiteMetricSettingsFailureAction,
    updateSiteReportSettingsFailureAction,
} from '../monitoring/monitoring.actions';
import {
    createSiteTemplatesFailureAction,
    deploySiteFailureAction,
    downloadSiteDeploymentFailureAction,
} from '../deployment/deployment.actions';
import {
    getPlayerOptionsFailureAction,
    getSitePlayerFailureAction,
    initializeSitePlayerFailureAction,
    updateSitePlayerFailureAction,
} from '../player/player.actions';
import { getPhoneCallFailureAction } from '../support/support.actions';
import { showSnackBarAction } from '../snack-bar/snack-bar.actions';
import { emptyAction } from '../ui/ui.actions';

@Injectable()
export class ErrorsEffects {
    handleError$ = createEffect(() =>
        this.actions$.pipe(
            ofType(
                getCompaniesFailureAction,
                getPermissionsFailureAction,
                getSitesFailureAction,
                deleteUserFailureAction,
                getSiteUsersFailureAction,
                editUserPermissionsFailureAction,
                inviteUserFailureAction,
                getSiteFailureAction,
                getSiteFeaturesFailureAction,
                getSiteMetricsConfigFailureAction,
                getSiteDeviceCareConfigFailureAction,
                updateSiteMetricSettingsFailureAction,
                updateSiteReportSettingsFailureAction,
                updateSitePlayerFailureAction,
                initializeSitePlayerFailureAction,
                createSiteTemplatesFailureAction,
                clearDeviceCareFailureAction,
                downloadSiteDeploymentFailureAction,
                deploySiteFailureAction,
                activateDeviceCareFailureAction,
                getSiteLicenseRawFailureAction,
                getSiteMetricDataFailureAction,
                getPhoneCallFailureAction,
                getPlayerOptionsFailureAction,
                getSitePlayerFailureAction,
            ),
            map(({ error, type }) => {
                console.error(type);
                console.error(error);

                if (!error?.error?.message) {
                    return emptyAction();
                }

                return showSnackBarAction({
                    config: {
                        type: SnackBarType.FAILED,
                        description: error.error.message,
                        actionLabel: 'Dismiss',
                    },
                });
            }),
        ),
    );

    constructor(private readonly actions$: Actions) {}
}
